export default __webpack_public_path__ + "static/media/banner_graphic.11f74f21.svg";